module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": _vm.qrcode
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": _vm.click
    }
  }, [_vm._v("关闭")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "company-name"
  }, [_vm._v("关注智慧食堂")]), _vm._v(" "), _c('div', {
    staticClass: "tip-color"
  }, [_vm._v("长按左边二维码")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-93171b76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/qrcode-tip.vue
// module id = 880
// module chunks = 34